var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z",
    fill: "#3E475A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1439 7.22998L13.7917 17.4556L6.0957 25.7696H7.8279L14.5659 18.4904L20.0098 25.7696H25.9041L17.8259 14.9689L24.9893 7.22998H23.2572L17.052 13.9337L12.0382 7.22998H6.1439ZM8.69118 8.50578H11.399L23.3565 24.4938H20.6487L8.69118 8.50578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.f1ec0745279b566715c46cd097eaf0cf.svg";
export { ForwardRef as ReactComponent };